import * as mainTerms from './mainTerms';
import {column} from './component/column';
import {select} from './component/select';
import {query} from './component/query';
import {button} from './component/button';
import {img} from './component/img';
import {form} from './component/form/index';

export const ComponentTerms = {
    general: {
        invalidFormat: '올바르지 않은 포맷',
        selectAppMsg: '앱을 선택해주세요',
    },
    column: column,
    select: select,
    query: query,
    button: button,
    img: img,
    form: form,
}
